import React from 'react';

export default function Intro() {
  return (
    <>
      <h1>VA chatbot</h1>
      <div className="va-introtext">
        <p>Use our chatbot to find information on VA.gov.</p>
      </div>
    </>
  );
}
